import Vue from 'vue'
import GLOBAL from '../actions/global'
import SESSION from '../actions/session'

const initialState = {
  user: null,
}

const getters = {
  user: state => state.user,
}

const actions = {
  [SESSION.VALIDATE]: ({ dispatch }) => new Promise((resolve, reject) =>
    dispatch(GLOBAL.LOADING, () =>
      $API.sessions.read()
        .then(data => {
          dispatch(SESSION.SUCCESS, data.session.user)
          resolve(data.session.user)
        })
        .catch(e => {
          if (e.responseStatus === 403) return reject(e)
          throw e
        }))),

  [SESSION.SUCCESS]: ({ commit }, user) => {
    localStorage.setItem('auth-token', user.auth_token)
    commit(SESSION.SUCCESS, user)
  },
}

const mutations = {
  [SESSION.SUCCESS]: (state, user) => {
    state.user = user
  },
}

export default {
  state: initialState,
  getters,
  actions,
  mutations,
}
